// Core imports
import * as React from 'react';
import localeFormating from 'src/translation/localeFormating';

// Components imports

// Models imports
import ClaimDetailsModel from 'src/model/ClaimDetails.model';

// Style and misc imports
import './EmailClaimCard.scss';
import ClaimStatusModel from 'src/model/ClaimStatus.model';

class EmailClaimCard extends React.Component<IEmailClaimCardProps, any> {
  /* 
    statusFlagGetter : Reads the status and assign a css class 
   */
  private statusFlagGetter = (invoice: any) => {
    const flags = { type: '', icon: '' };
    switch (invoice.status) {
      case 'PAST DUE':
        flags.type = 'past-due';
        flags.icon = 'rpds-error';
        break;
      case 'DUE':
        flags.type = 'due';
        flags.icon = 'rpds-alert-bell';
        break;
      default:
      case 'PAID':
        flags.type = 'paid';
        flags.icon = 'rpds-check-circle';
        break;
    }

    return flags;
  };

  public render() {
    const { t, claim, removeClaimFromSelected } = this.props;

    // const statusIcon = this.statusFlagGetter(invoice);

    return (
      <div className="rp-email-invoice-card">
        <div className="data-container">
          <span className="invoice-data--">{claim.claimNo}</span>
          <span className="invoice-data--">{claim.claimOriInvNo}</span>
        </div>
        <span
          className="invoice-data--clear-invoice"
          onClick={() => {
            removeClaimFromSelected(claim);
          }}
        >
          <i className="rpds-close" />
        </span>
      </div>
    );
  }
}

export default EmailClaimCard;

interface IEmailClaimCardProps {
  removeClaimFromSelected(claim: ClaimStatusModel): void;
  t: any;
  claim: ClaimStatusModel;
}
